import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c0bfbddc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = {
  key: 0,
  class: "divider"
}

import MobileNavigationBar from "@/components/layouts/MobileNavigationBar/MobileNavigationBar.vue";
import { MobileNavigationProps } from "@/types/app";
interface SettingsDetailsProps extends MobileNavigationProps {
  title: string;
  isContentWide?: boolean;
  gap?: number;
  isDividerHidden?: boolean;
  handleRedirect?: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsDetails',
  props: {
    title: {},
    isContentWide: { type: Boolean },
    gap: {},
    isDividerHidden: { type: Boolean },
    handleRedirect: { type: Function },
    hideDivider: { type: Boolean },
    handleAction: { type: Function },
    actionTitle: {},
    iconType: {},
    isActionDisabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "container",
    style: _normalizeStyle(`gap:${_ctx.gap}px`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(MobileNavigationBar, _normalizeProps(_guardReactiveProps(props)), null, 16),
      (!_ctx.isDividerHidden)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["content", {
        'wide-content': !!_ctx.isContentWide,
      }])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 4))
}
}

})